import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, afterNextRender, Injector } from '@angular/core';
import { NavigationEtat } from '../../core/navigation-etat';
import { APP_CLASSES } from '../classes-appli';
import { EtatVideComponent } from '../../ui/etat-vide/etat-vide.component';
import { IconeComponent } from '../../ui/icone/icone.component';
import { IndicateurChargementComponent } from '../../ui/indicateur-chargement/indicateur-chargement.component';

/**
 * Écran de chargement et d'erreur des navigations (core/navigation-etat.ts), au-dessus de l'application :
 * jamais de page blanche au démarrage d'un dossier ni après un échec.
 */
@Component({
  selector: 'app-navigation-etat',
  imports: [EtatVideComponent, IconeComponent, IndicateurChargementComponent],
  templateUrl: './navigation-etat.component.html',
  styleUrl: './navigation-etat.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationEtatComponent {
  readonly etat = inject(NavigationEtat);
  readonly appClasses = APP_CLASSES;
  private readonly host: HTMLElement = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  private readonly injector = inject(Injector);

  constructor() {
    // Écran d'erreur : focus sur « Réessayer » (clavier).
    effect(() => {
      if (this.etat.echec()) {
        afterNextRender(() => this.host.querySelector<HTMLElement>('.btn-primary')?.focus(), { injector: this.injector });
      }
    });
  }
}
